import { useState } from 'react'
import { Plus } from 'lucide-react'
import { useCustomerTrackerStore } from '@/stores/customer-tracker-store'

export function AddCustomerButton() {
  const [isAdding, setIsAdding] = useState(false)
  const [name, setName] = useState('')
  const { addCustomer } = useCustomerTrackerStore()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (name.trim()) {
      addCustomer('', name.trim()) // Empty string for userId (shared customers)
      setName('')
      setIsAdding(false)
    }
  }

  if (isAdding) {
    return (
      <div className="absolute top-0 right-0 bg-card border border-border rounded-lg p-4 w-[300px] shadow-xl z-30">
        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Customer name..."
            autoFocus
            className="bg-background text-foreground px-3 py-2 rounded border border-border focus:border-primary focus:outline-none text-sm"
          />
          <div className="flex gap-2">
            <button type="submit" className="bg-primary text-white px-4 py-2 rounded hover:opacity-90 transition-opacity text-sm font-medium flex-1">
              Add
            </button>
            <button type="button" onClick={() => setIsAdding(false)} className="bg-card border border-border text-foreground px-4 py-2 rounded hover:bg-background transition-colors text-sm font-medium">
              Cancel
            </button>
          </div>
        </form>
      </div>
    )
  }

  return (
    <button onClick={() => setIsAdding(true)} className="bg-primary text-black px-3 py-1.5 rounded hover:opacity-90 transition-opacity flex items-center gap-2 text-sm font-semibold shadow-lg">
      <Plus className="w-4 h-4" />
      Add Customer
    </button>
  )
}
